/**
 * Flash Book API 서비스
 */
import api from './api';

const versions = new Map();
const flashOwners = new Map();
function remember(result, id) {
    if (result.version && id) versions.set(String(id), result.version);
    for (const flash of result.flashes || (result.flash ? [result.flash] : [])) {
        if (flash.planche_id) flashOwners.set(String(flash.id), String(flash.planche_id));
    }
    return result;
}
const flashbookApi = {
    // ============ Planche ============

    /**
     * 내 플렁슈 목록 조회
     */
    getPlanches: () => api.get('/flashbook/planches'),

    /**
     * 단일 플렁슈 조회 (플래시 포함)
     */
    getPlanche: async (id) => remember(await api.get(`/flashbook/planches/${id}`), id),

    /**
     * 플렁슈 생성
     */
    createPlanche: async (data) => { const r = await api.post('/flashbook/planches', data); return remember(r, r.planche.id); },

    /**
     * 플렁슈 수정
     */
    updatePlanche: async (id, data) => remember(await api.put(`/flashbook/planches/${id}`, { expected_version: versions.get(String(id)), ...data }), id),

    /**
     * 플렁슈 삭제
     */
    deletePlanche: (id) => api.request(`/flashbook/planches/${id}`, { method: 'DELETE', body: JSON.stringify({ expected_version: versions.get(String(id)) }) }),

    // ============ Flash ============

    /**
     * 내 플래시 목록 조회
     * @param {string} plancheId - 필터용 (optional)
     */
    getFlashes: (plancheId) => {
        const params = plancheId ? `?planche_id=${plancheId}` : '';
        return api.get(`/flashbook/flashes${params}`);
    },

    /**
     * 내 플래시 원본 이미지 전체 ZIP 다운로드
     */
    downloadAllFlashes: () => api.download('/flashbook/flashes/download', 'flashbook_flashes.zip'),

    /**
     * 단일 플래시 조회
     */
    getFlash: (id) => api.get(`/flashbook/flashes/${id}`),

    /**
     * 플래시 생성
     */
    createFlash: async (data) => remember(await api.post('/flashbook/flashes', { expected_version: versions.get(String(data.planche_id)), ...data }), data.planche_id),

    /**
     * 플래시 수정
     */
    updateFlash: async (id, data) => { const owner = flashOwners.get(String(id)); const bookingSold = Object.keys(data).length === 1 && data.available === false; return remember(await api.put(`/flashbook/flashes/${id}`, { expected_version: bookingSold ? undefined : versions.get(owner), ...data }), bookingSold ? undefined : owner); },

    /**
     * 플래시 삭제
     */
    deleteFlash: async (id) => remember(await api.request(`/flashbook/flashes/${id}`, { method: 'DELETE', body: JSON.stringify({ expected_version: versions.get(flashOwners.get(String(id))) }) }), flashOwners.get(String(id))),

    // ============ 이미지 업로드 ============

    /**
     * 플래시 이미지 업로드 (max 10MB)
     * @param {File} file - 이미지 파일 (JPG/PNG)
     */
    uploadImage: async (file) => {
        const formData = new FormData();
        formData.append('image', file);
        // api.upload 메서드 사용 (FormData 전용)
        return api.upload('/flashbook/upload', formData);
    },

    // ============ 검색 ============

    /**
     * 플래시/플렁슈 통합 검색
     * @param {string} query - 검색어 (예: "45", "N.45")
     * @param {string} type - 검색 대상: 'flash' 또는 'planche'
     * @param {number} limit - 결과 제한 (기본값: 50)
     */
    search: (query, type = 'flash', limit = 50) => {
        const params = new URLSearchParams({ q: query, type, limit: String(limit) });
        return api.get(`/flashbook/search?${params.toString()}`);
    }
};

export default flashbookApi;
